import React from "react";
import { isMushroomGuestActive } from "../guest/mushroom-guest-session";

export const MushroomReadOnlyContext = React.createContext<{
  readOnly: boolean;
}>({
  readOnly: false,
});

export function MushroomReadOnlyProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const readOnly = isMushroomGuestActive();

  return (
    <MushroomReadOnlyContext.Provider value={{ readOnly }}>
      {children}
    </MushroomReadOnlyContext.Provider>
  );
}
